import type { Follow } from "@tandemdiabetes/sugarmate-api-react-client"
import { FollowState } from "@tandemdiabetes/sugarmate-api-react-client"

export const defaultFollow: Follow = Object.freeze({
  id: "",
  account_id: -1,
  following_account_id: -1,
  tandem_account_id: "",
  is_self: true,
  is_follow_only: false,
  nickname: null,
  sharer_firstname: null,
  sharer_lastname: null,
  follower_email: "",
  follower_firstname: null,
  follower_lastname: null,
  state: FollowState.Active,
  display_settings: {
    range_normal_bottom: 70,
    range_normal_top: 180,
    urgent_low: 55,
  },
  sleep_settings: {
    start_time: "00:00",
    end_time: "08:00",
  },
  critical_alert_settings: {
    start_time: "00:00",
    end_time: "08:00",
  },
  apple_watch_settings: {
    watch_24hr_time: false,
    watch_hide_time: false,
    show_watch_delta: false,
  },
  created_at: "",
  updated_at: "",
  deleted_at: null,
})
